import { Injectable } from '@angular/core';
import { BlockModel, BlockType } from '../../core/block/block.model';
import { TermModel } from '../../core/term/term.model';
import { ModalConfirmationComponent } from '../modal-confirmation/modal-confirmation.component';
import { ModalExplanationComponent } from '../modal-explanation/modal-explanation.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Injectable({
  providedIn: 'root',
})
/** Service allowing data manipulation regarding Topics */
export class TopicService {
  public topicIncludeBlocks: Array<BlockModel> = [];
  public topicComplexityMaxValue = 0;
  public copiedTerms: Array<TermModel> = [];

  constructor(private modalService: NgbModal) {}

  /**
   * Method to evaluate a topic complexity based on its blocks.
   */
  evaluateTopicComplexity(blocks: BlockModel[]): number {
    let topicComplexity = 0;
    blocks.forEach(block => {
      if (block.type === BlockType.SIMPLE_LIST) {
        if (block.columns?.[0]) {
          topicComplexity += block.columns[0].length;
        } else {
          topicComplexity += 0;
        }
      }
      if (block.type === BlockType.TERMS_TO_EXCLUDE) {
        // Do nothing
      }
      if (block.type === BlockType.NEARBY_TERMS || block.type === BlockType.EXPRESSIONS_COMBINATIONS) {
        let complexityToAdd = 1;
        let testEmptyList = 0;
        for (const column of block.columns ?? []) {
          if (column != null) {
            complexityToAdd = complexityToAdd * column.length;
            testEmptyList += column.length;
          }
        }
        if (testEmptyList === 0) {
          complexityToAdd = 0;
        }
        topicComplexity += complexityToAdd;
      }
    });
    return topicComplexity;
  }

  setCopiedTerms(terms: Array<TermModel>) {
    this.copiedTerms = structuredClone(terms);
  }

  getCopiedTerms() {
    return structuredClone(this.copiedTerms);
  }

  openAlertModal(): void {
    const modal = this.modalService.open(ModalConfirmationComponent, { ariaLabelledBy: 'modal-basic-title', centered: true });
    modal.componentInstance.title = 'content.modal-alert-topic-title';
    modal.componentInstance.content = 'content.modal-alert-topic-content';
    modal.componentInstance.btnName = 'button.modal-alert-yes';
    modal.componentInstance.alertMode = true;
  }

  openComplexityAlertModal(): void {
    const modal = this.modalService.open(ModalExplanationComponent, { ariaLabelledBy: 'modal-basic-title', centered: true });
    modal.componentInstance.title = 'content.modal-alert-topic-complexity-title';
    modal.componentInstance.content = 'content.modal-alert-topic-complexity-content';
    modal.componentInstance.content2 = 'content.modal-alert-topic-complexity-content2';
    modal.componentInstance.mailto = 'content.modal-alert-topic-complexity-mailto';
    modal.componentInstance.btnName = 'button.modal-alert-topic-complexity-yes';
  }
}
